window.requestResetPasswordRecaptchaSuccess = () => {
  document.getElementById('request-reset-password-form').submit();
};

export function init() {
}

export function destroy() {
}
